import { OnInit, Component, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpAlertService } from 'src/app/services/http-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from 'src/app/services/admin.service';
import { ArrangerDetails } from 'src/app/intefaces/arranger-details.interface';

@Component({
    selector: 'app-arranger-commission-form',
    templateUrl: './arranger-commission-form.component.html',
    styleUrls: ['./arranger-commission-form.component.scss']
})
export class ArrangerCommissionFormComponent implements OnInit {

    @Input() userId: number;

    isDataReady: boolean = false;
    arrangerCommissionForm: FormGroup;
    isEditingCommission: boolean = false;
    commissionPreviousValue: any;
    arrangerDetails: ArrangerDetails;

    constructor(
        private formBuilder: FormBuilder,
        private alertService: HttpAlertService,
        private translate: TranslateService,
        private adminService: AdminService) {

        this.arrangerCommissionForm = this.formBuilder.group({
            user_id: [0, Validators.required],
            commission: [0, [Validators.required, Validators.max(100), Validators.min(0)]],
        });

    }

    ngOnInit(): void {
        this.adminService.getArrangerCommission(this.userId).subscribe((response: any) => {
            this.arrangerDetails = response.data.arranger_details;
            this.arrangerCommissionForm.patchValue(this.arrangerDetails);
            setTimeout(() => {
                this.arrangerCommissionForm.disable();
            }, 100);
            this.isDataReady = true;
        });
    }

    public onEditCommission(): void {
        this.commissionPreviousValue = this.arrangerCommissionForm.value;
        this.isEditingCommission = true;
        this.arrangerCommissionForm.enable();
    }

    public cancelForm(): void {
        this.arrangerCommissionForm.setValue(this.commissionPreviousValue);
        this.isEditingCommission = false;
        this.arrangerCommissionForm.disable();
    }

    public onSubmitArrangerCommissionForm(): void {
        this.arrangerCommissionForm.disable();
        this.adminService.updateArrangerCommission(this.arrangerCommissionForm.value).subscribe((response: any) => {
            this.translate.get('data_updated_success').subscribe(t => {
                this.alertService.success(t);
            });
        }, error => {
            this.translate.get('data_updated_error').subscribe(t => {
                this.alertService.error(t);
            });
        });
        this.isEditingCommission = false;
    }


}